<template lang="pug">
el-row
  el-col(:sm="24")
    #bar-chart(ref="chart", style="height:400px")
</template>

<script>
import echarts from 'echarts'
import * as dateUtil from '../lib/dateUtil'

export default {
  props: {
    rawData: {default: false},
    tickFormat: {default: 'YYYY-MM-DD'},
    dataInfo: {},
    dataKeys: {}
  },
  methods: {

  },
  watch: {
    rawData () {
      const selected = {}
      Object.keys(this.dataInfo).forEach(k => selected[k] = this.dataKeys.includes(k))

      this._chart.setOption({
        legend: {
          formatter: name => this.dataInfo[name].name,
          data: Object.keys(this.dataInfo),
          selected: selected
        },
        tooltip: {
          trigger: 'axis',
          formatter: (params, ticket, cb) => {
            const html = [dateUtil.format(params[0].name, this.tickFormat)]
            params.forEach(p => {
              html.push(`
                <span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:${p.color}"></span>
                <span>${this.dataInfo[p.seriesName].name}</span>: ${this.common.formatPrice(p.value)}
              `)
            })
            // cb(ticket, html.join('<br>'))
            return html.join('<br>')
          },
          // formatter: '{b0}: {c0}<br />{b1}: {c1}',

          axisPointer : {
            type : 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.rawData.x,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            formatter: val => dateUtil.format(val, this.tickFormat)
          }
        },
        yAxis: {},
        series: Object.keys(this.dataInfo).map(k => {
          return {
            barGap: 0,
            type: 'bar',
            name: k,
            data: this.rawData[k],
            stack: k.substr(0, 2),
            label: {
              normal: {
                show: true,
                position: this.dataInfo[k].labelPosition,
                formatter: (params => params.value ? Math.round(params.value) : '')
              }
            },
            itemStyle: {
              normal: {
                color: this.dataInfo[k].color
              }
            }
          }
        })
      })
    },

    dataKeys (newVal, oldVal) {
      const selected = {}
      Object.keys(this.dataInfo).forEach(k => selected[k] = newVal.includes(k))

      this._chart.setOption({
        legend: { selected: selected}
      })
    }
  },
  mounted () {
    this._chart = echarts.init(this.$refs.chart)
  },
  beforeDestroy () {

  }
}
</script>